:host {
  display: block;
}
aui-header {
  background-color: var(--color-white);
  border-block-end: 1px solid var(--color-gray-light);
  display: block;

  [data-ref='product-name'] {
    color: var(--color-gray-dark);
    font-size: var(--font-size-lg);
    font-weight: var(--font-weight-light);
    margin-block-start: 1px;
  }
  s-container {
    block-size: 2.625rem;
    padding-inline-end: var(--padding-sm); // adjust due to padding in button
  }
  img {
    block-size: 1.25rem;
  }
  s-icon {
    font-size: 1rem;
  }
  s-menu {
    s-dropdown[open] {
      [slot='dropdown-content'] {
        border-radius: 0 0 4px 4px;
        max-block-size: none;
        overflow: visible;
      }
      button.ghost[slot='menu-trigger'] {
        background-color: var(--color-blue-lightest);
        border: transparent 1px solid;
        color: var(--color-blue-darkest);
        [data-ref='icon-container'] {
          background-color: var(--color-blue-lighter);
        }
      }
    }
    [slot='menu-trigger'] > s-icon {
      vertical-align: -3px;
    }
  }
  a:hover {
    text-decoration: none;
  }

  button[data-ref='zoom-in-help'],
  button[data-ref='ipua-chat'] {
    block-size: 2.625rem;
    border-radius: 0;
    padding-inline: var(--padding-sm);
  }

  &[sidenavheader] {
    inset-block-start: 0;
    padding-inline-end: var(--padding-xs);
    position: sticky;
    z-index: 100;
    s-container {
      max-inline-size: unset;
      padding-inline-start: var(--padding-lg);
    }

    button[data-ref='zoom-in-help'],
    button[data-ref='ipua-chat'] {
      block-size: 1.875rem;
      border-radius: 4px;
      color: var(--color-gray-darkest);
      margin-inline: var(--margin-xs);
      padding-inline: var(--padding-xs);
      &.open {
        background-color: var(--color-blue-lighter);
        border-color: var(--color-blue-lighter);
        color: var(--color-blue-darkest);
      }
      &:hover {
        background-color: var(--color-gray-lightest);
      }
    }

    s-menu s-dropdown[open] button[slot='menu-trigger'] {
      background-color: var(--color-blue-lighter);
      border-color: var(--color-blue-lighter);
      color: var(--color-blue-darkest);
    }

    s-menu [slot='menu-trigger'],
    a[data-ref='login'] {
      align-items: center;
      block-size: 1.875rem;
      border-radius: 4px;
      color: var(--color-gray-darkest);
      display: inline-flex;
      justify-content: center;
      margin: var(--margin-xs);
      min-inline-size: 1.875rem;
      padding-block: 0;
      padding-inline: var(--padding-xs);

      &:hover {
        background-color: var(--color-gray-lightest);
      }
    }

    button[data-ref='sidenav-trigger'] {
      color: var(--color-gray-darkest);
      margin-inline-end: var(--margin-xs);
      &.open {
        background-color: var(--color-blue-lighter);
        color: var(--color-blue-darkest);
        &:hover {
          background-color: var(--color-blue-lighter);
        }
      }
      &:hover {
        background-color: var(--color-gray-lightest);
      }
    }

    s-menu [slot='menu-items'] {
      margin-inline-end: var(--margin-xs);
    }

    @media only screen and (max-width: 839px) {
      s-container {
        padding-inline-start: var(--padding-xs);
      }
    }

    @media only screen and (max-width: 599px) {
      .collapses.icon-leading {
        margin-block: 0.375rem;
        margin-inline: 0.1875rem;
        s-icon {
          margin: 0;
        }
      }

      s-menu[data-ref='account-menu'] {
        margin-inline-end: var(--margin-xs);
      }
      s-menu [slot='menu-items'] {
        margin-block-start: var(--margin-xs);
        margin-inline-end: 0.1875rem;
      }
    }
  }
  s-menu [slot='menu-trigger'],
  a[data-ref='login'] {
    align-items: center;
    block-size: 2.625rem;
    border-radius: 0;
    display: inline-flex;
    padding-block: 0;
    padding-inline: var(--padding-sm);
  }

  s-menu > [slot='menu-items'] > h4 {
    align-items: center;
    block-size: 2.25rem;
    border: transparent solid 1px;
    font-size: var(--font-size-label);
    font-weight: var(--font-weight-semibold);
    margin-block: 0;
    margin-inline: var(--margin-xs);
    padding-block: var(--padding-xs);
    padding-inline: var(--padding-sm);
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }

  s-menu > [slot='menu-items'] {
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }

  [data-ref='icon-container'] {
    background-color: var(--color-gray-lighter);
    block-size: 1.875rem;
    border-radius: 50%;
    inline-size: 1.875rem;
    text-transform: uppercase;
  }
  s-menu [slot='menu-trigger']:active,
  [data-ref='login']:active {
    background-color: var(--color-white);
  }
  s-menu [slot='menu-items'] {
    border-radius: 0 0 4px 4px;
    inset-inline: auto 0;
    max-inline-size: 296px;
    div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    hr[role='separator'] {
      margin-block: 0.5625rem;
      margin-inline: 0;
    }

    div.section-header {
      border: 1px solid transparent;
      margin-block: 0.1875rem;
      margin-inline: var(--margin-sm);
      min-block-size: 2.25rem;
      padding-block: 0.3125rem;
      padding-inline: var(--padding-sm);
      user-select: text;
    }
  } /* Override menu default positioning, all should open to left */

  &.hide-account-menu [data-ref='account-menu'],
  &.hide-account-menu a[data-ref='aui-header.account.login'],
  &.hide-account-products-usage a[data-ref='aui-header.account-menu.products-usage'],
  &.hide-account-support-cases a[data-ref='aui-header.account-menu.support-cases'],
  &.hide-account-billing a[data-ref='aui-header.account-menu.billing'],
  &.hide-account-products-usage.hide-account-support-cases.hide-account-billing hr[data-ref='account-features-separator'],
  &.hide-account-id.hide-account-overview.hide-account-users-admins.hide-account-companies.hide-account-security-settings hr[data-ref='account-features-separator'],
  &.hide-account-change-password a[data-ref='aui-header.account-menu.change-password'],
  &.hide-account-id [data-ref='aui-header.account-menu.id'],
  &.hide-account-my-downloads [data-ref='aui-header.account-menu.downloads'],
  &.hide-account-overview [data-ref='aui-header.account-menu.overview'],
  &.hide-account-users-admins [data-ref='aui-header.account-menu.users'],
  &.hide-account-companies [data-ref='aui-header.account-menu.companies'],
  &.hide-account-security-settings [data-ref='aui-header.account-menu.sign-in-settings'] {
    display: none;
  }

  @media only screen and (max-width: 1259px) {
    s-container {
      padding-inline-end: var(--padding-sm);
    }
  }
  @media only screen and (max-width: 839px) {
    s-container {
      padding-inline-end: 0;
    }
  }

  .new-feature-tag {
    background-color: var(--color-orange-light);
    border: 2px solid var(--color-white);
    inset-block-start: 0;
    inset-inline-start: 0;
    position: absolute;
    z-index: 101;
  }
}
